/*!
 * slxControls v1.1.0 (http://selerix.com)
 * Copyright 2017 Selerix Systems, Inc. All Rights Reserved.
 * This is unpublished proprietary source code of Selerix, Inc. The
 * copyright notice above does not evidence any actual or intended
 * publication of such source code.
 *
 * Dependencies: jQuery v1.10+, Bootstrap v3.2+, polyfills.js
 */
(function () {
	'use strict';
	var x = window.SlxControl;

    /*
	 * slx.autocomplete
	 * Dependencies: slx.core
	 */
	x.slx.autocomplete = function (el) {
		var that = this;
		x.slx.base.apply(that, arguments);

		el = that._element;
		if (el === void 0) { return this; }
		else if (el.length === 0) { return el; }

		that.id = that.id || el.slxUniqueId();
		that.selector = '#' + that.id;
		that.items = that.items || [];
		if (that.highlight === void 0) { that.highlight = el.data('highlight') === false ? false : true; }
		that.container = x(that.selector + '_container');
		that.service = that.service || el.data('service') || null;
		that.dropDownHeight = that.dropDownHeight || el.data('dropdownheight') || null;
		that.showArrow = that.showArrow || el.data('showarrow');
		that.template = that.template || that.container.find('.slx-autocomplete-template').html() || null;
		that.templateID = that.templateID || el.data('templateid') || null;
		that.onChange = that.onChange || el.attr('onchange') !== void 0 ? new Function(el.attr('onchange').replace('javascript:', '')) : null;

		if (that.templateID !== null) {
			var t = x('#' + that.templateID);
			if (!t.hasClass('slx-autocomplete-template')) { t.addClass('slx-autocomplete-template'); }
			that.template = t.html();
		}

		var _filtered = null;
		var _label = x('label[for="' + that.id + '"]');

		var _hidden = this.container.find(that.selector + '_value');
		if (_hidden.length === 0) { _hidden = x(that.selector + '_value'); }

		that.value = function (v) {
			if (v === void 0) { return _hidden.jqVal(); }
			else {
				var ischange = v.toString() !== (_hidden.jqVal() || '');
				var h = _hidden.jqVal(v);
				if (ischange) { _hidden.trigger('change'); el.trigger('change'); }
				else that.close();
				return h;
			}
		};
		that.text = function (v) {
			if (v === void 0) { return el.jqVal(); }
			else {
				if (v === '') { that.value(''); }
				return el.jqVal(v);
			}
		};
		that.selectedIndex = function () {
			return that.items.findIndex(function (i) {
				if (typeof (i) === 'string') { return i === that.text(); }
				else { return i.Value.toString() === that.value(); }
			});
		};
		that.selectedItem = function () {
			var i = that.selectedIndex();
			return (i >= 0 && that.items.length > 0) ? that.items[i] : null;
		};
		that.select = function (i) {
			var item = i;
			if (typeof (item) === 'number') { item = that.items[i]; }
			that.value(typeof (item) === 'string' ? item : item.Value);
		};
		that.selectedFilteredIndex = function () {
			var f = _filtered || that.items;
			return f.findIndex(function (i) {
				if (typeof (i) === 'string') { return i === that.text(); }
				else { return i.Value.toString() === that.value(); }
			});
		};
		that.selectedFilteredItem = function () {
			var f = _filtered || that.items;
			var i = that.selectedFilteredIndex();
			return (i >= 0 && f.length > 0) ? f[i] : null;
		};

		var _preventDefault = function (event) {
			var k = event.keyCode || event.which;
			if ([13, 37, 38, 39, 40].indexOf(k) > -1) {
				event.preventDefault();
				return false;
			}
			return true;
		};

		var _options, _blurTimeout = null, _changeTimeout = null, _autoChangeTimeout = null, _isScrolling = false, _selectedVal = null;
		that.close = function (opt) {
			that.container.removeClass('open');
			opt = opt || _options;
			_filtered = null;
			if (opt !== void 0) { opt.off('click.slx').remove(); }
			el.off('click.slx').trigger('closed');
			x(document).off('click.slx');
			if (_blurTimeout !== null) { clearTimeout(_blurTimeout); }
			_options = void 0;
			el.closest('form').off('keydown.slx.ac');
			x(document).off('keydown.slx.ac');
		};
		that.open = function () {
			that.container.addClass('open');
			x('.slx-autocomplete-container:not(#' + that.container.prop('id') + ') .slx-autocomplete-options').each(function () { x(this).remove(); });
			_filtered = _filtered || that.items;

			if (_filtered.length === 0) { that.close(); return; }
			_options = that.container.find('.slx-autocomplete-options');
			if (_options.length > 0) { _options.empty(); }
			else { that.container.append(_options = x('<UL/>').addClass('slx-autocomplete-options').attr('aria-labelledby', _label.prop('id'))); }

			if (that.dropDownHeight !== null) { _options.css('max-height', that.dropDownHeight); }

			var a = that.text(), b = a.toLowerCase(), c = a.toUpperCase(), d = b.length > 0 ? b[0].toUpperCase() + b.substring(1) : '';
			var txt;
			for (var i = 0; i < _filtered.length; i++) {
				var item = _filtered[i];
				var li = x('<LI/>');
				if (typeof (item) === 'string') {
					txt = a.length > 0 && that.highlight ? x.htmlEncode(item).mark(a).mark(b).mark(c).mark(d) : x.htmlEncode(item);
					li.attr('data-val', item).html(item);
					_options.append(li);
					continue;
				}
				li.attr('data-val', item.Value);
				if (that.template !== null) {
					item.Content = that.template;
					for (var p in item) {
						if (p === 'Content') { continue; }
						txt = x.htmlEncode(new String(item[p]));
						if (that.text().length > 0 && that.highlight) { txt = txt.mark(a).mark(b).mark(c).mark(d); }
						item.Content = item.Content.replaceAll('{' + p + '}', txt);
					}
					li.html(item.Content);
				} else {
					txt = a.length > 0 && that.highlight ? x.htmlEncode(item.Text).mark(a).mark(b).mark(c).mark(d) : x.htmlEncode(item.Text);
					li.html(txt);
				}
				li.on('click.slx.ac', function (event) {
					clearTimeout(_autoChangeTimeout);
					_hidden.jqVal('');
					that.value(x(this).data('val'));
					_selectedVal = null;
					that.close();
				});
				_options.append(li);
			}

			el.closest('form').off('keydown.slx.ac').on('keydown.slx.ac', _preventDefault);
			x(document).off('click.slx.ac').on('click.slx.ac', function () { x('.slx-autocomplete-options').each(function () { x(this).remove(); }); });
			x(document).off('keydown.slx.ac').on('keydown.slx.ac', _preventDefault);
			_options.off('click.slx.ac').on('click.slx.ac', function (event) { x(this).stopBubble(event); });
			_options.off('scroll.slx.ac').on('scroll.slx.ac', function () {
				_isScrolling = true;
				if (_options.data('timeout')) { clearTimeout(_options.data('timeout')); }
				_options.data('timeout', setTimeout(function () { _isScrolling = false; }, 150));
			});
			el.off('click.slx.ac').on('click.slx.ac', function (event) { x(this).stopBubble(event); }).trigger('open');
		};
		that.search = function (q, callback) {
			q = q || '';
			if (that.service !== null) {
				_filtered = null;
				x.ajax({
					url: that.service,
					data: JSON.stringify({ query: q || '' }),
					dataType: 'JSON',
					cache: false,
					type: 'POST',
					processData: true,
					contentType: 'application/json',
					async: false,
					success: function (result) {
						that.items = result || [];
						el.trigger('search');
						if (typeof (callback) === 'function') { callback(that.items); }
					},
					error: function (err, textStatus) { console.log(err.responseText); }
				});
			} else {
				_filtered = that.items.filter(function (a) {
					return typeof a === 'string' ? a.toLowerCase().startsWith(q.toLowerCase()) : a.Text.toLowerCase().startsWith(q.toLowerCase()) || a.Value.toLowerCase() === q.toLowerCase();
				});
				el.trigger('search');
				if (typeof (callback) === 'function') { callback(_filtered); }
			}
		};

		var _btn = this.container.find('.slx-autocomplete-arrow');

		/* initialization */
		(function () {
			el.attr('onchange', null);

			if (_label.length === 0) { _label = x('label[for="' + el.prop('name') + '"]').attr('for', that.id); }
			if (_label.length > 0 && _label.prop('id').length === 0) { _label.attr('id', that.id + '_label'); }

			if (that.container.length === 0) {
				el.wrap(x('<DIV/>').attr('id', that.id + '_container').attr('data-target', that.selector).addClass('slx-autocomplete-container'));
				that.container = x(that.selector + '_container');
			}

			if (el.prop('tagName') === 'SELECT') {
				_hidden = el;
				_hidden.attr('id', that.id + '_value').hide();
				_hidden.after(el = x('<INPUT/>').attr('type', 'text').attr('id', that.id).attr('name', that.id));

				x.each(_hidden.attr('class').split(/\s+/), function (i, a) {
					_hidden.removeClass(a);
					el.addClass(a);
				});

				that.items.length = 0;
				_hidden.find('option').each(function () {
					var opt = x(this);
					that.items.push({ Value: opt.val(), Text: opt.jqText() });
					if (opt.prop('selected')) {
						el.data('original-val', opt.jqText());
						el.jqVal(opt.text());
					}
				});
			}

			if (!el.hasClass('slx-autocomplete')) { el.addClass('slx-autocomplete'); }
			if (!el.data('original-val')) el.data('original-val', el.jqVal());
			el.attr('autocomplete', 'off');

			if (_hidden.length === 0) {
				el.before(_hidden = x('<INPUT/>').attr('id', that.id + '_value').attr('type', 'hidden').attr('name', that.id + '_value'));
				if (el.data('value') !== void 0) { _hidden.val(el.data('value')); }
				_hidden.data('original-val', _hidden.jqVal());
			}
			if (_btn.length === 0) {
				el.after(_btn = x('<BUTTON/>').attr('type', 'button').attr('aria-haspopup', 'true').attr('aria-expanded', 'false').attr('tabindex', '-1').addClass('slx-autocomplete-arrow'));
				_btn.append(x('<SPAN/>').addClass('caret'));
			}
			if (that.showArrow === false) { _btn.hide(); }
			else if (that.container.is(':visible')) {
				var c = that.container.width(), t = el.outerWidth();
				if (t - 2 <= c) { _btn.css('right', (c - t) + 'px'); }
				else if (t - 2 > c) { _btn.css('right', '-' + Math.round(t - c) + 'px'); }
			}

			el.jqVal(el.jqVal());
			setTimeout(function () { el.trigger(x.Event('render')); }, 0);
		})();

		/* events */
		(function () {
			_hidden.off('change.slx.ac').on('change.slx.ac', function (event) {
				var item = that.selectedItem() || null;
				that.text(item !== null ? item.Text : '');
			});
			el.off('change.slx.ac').on('change.slx.ac', function (event) {
				var item = null;

				if (_options !== void 0) {
					_selectedVal = _options.children('.active').data('val') || null;
					clearTimeout(_changeTimeout);
					_changeTimeout = setTimeout(function () {
						if (_isScrolling) { return; }
						if (_selectedVal !== null) {
							_hidden.jqVal(_selectedVal);
							item = that.selectedItem();
							el.jqVal(typeof (item) === 'string' ? item : item.Text);
						}
						if (that.onChange !== null && typeof (that.onChange) === 'function') { that.onChange(); }
						that.close();
					}, 250);
					if (_selectedVal !== null) { return; }
				}

				if (!el.is(':focus') || that.container.find(':focus').length === 0) {
					_autoChangeTimeout = setTimeout(function () {
						item = that.text().length > 0 ?
							that.items.find(function (i) {
								if (typeof (i) === 'string') { return i.toLowerCase().startsWith(that.text().toLowerCase()); }
								else {
									return i.Text.toLowerCase().startsWith(that.text().toLowerCase());
								}
							}) || null : null;

						if (item !== null) {
							_hidden.jqVal(typeof (item) === 'string' ? item : item.Value);
							el.jqVal(typeof (item) === 'string' ? item : item.Text);
						} else {
							_hidden.jqVal('');
							el.jqVal('');
						}
						clearTimeout(_changeTimeout);
						that.close();
						if (that.onChange !== null && typeof (that.onChange) === 'function') { that.onChange(); }
					}, 200);
				}
			});
			that.container.off('keyup.slx.ac').on('keyup.slx.ac', function (event) {
				var k = event.keyCode || event.which;
				var opt, top;
				/* escape key */
				if (k === 27) { that.close(); }
				/* up arrow */
				else if (k === 38) {
					if (_options !== void 0 && _options.length > 0) {
						opt = _options.children('li.active').removeClass('active').prev();
						if (opt.length === 0) { return; }
						_options.jqFocus();
						opt.jqFocus().addClass('active');

						top = opt.is(':first-child') ? -opt.outerHeight() : Math.round(opt.position().top);
						if (top <= 0) {
							_options.scrollTop(_options.scrollTop() + top);
							top = Math.round(_options.scrollTop());
						}
					} else { that.search(that.text(), that.open); }
					/* down arrow */
				} else if (k === 40) {
					if (_options !== void 0 && _options.length > 0) {
						if (!_options.is(':visible')) { _options.show(); }
						_options.jqFocus();

						opt = _options.children('li.active');
						if (opt.is(':last-child')) { return; }

						opt = opt.removeClass('active').next();
						if (opt.length === 0) opt = _options.children('li:eq(0)');
						opt.jqFocus().addClass('active');

						top = opt.is(':first-child') ? 0 : Math.round(opt.position().top);
						if (top + opt.outerHeight() > _options.outerHeight()) { _options.scrollTop(_options.scrollTop() - (_options.outerHeight() - (top)) + opt.outerHeight()); }
						else if (top <= 0) { return; }
					} else { that.search(that.text(), that.open); }
					/* enter key */
				} else if (k === 13) {
					that.container.stopBubble(event);
					if (_options !== void 0 && _options.length > 0) {
						var active = _options.children('.active');
						if (active.length === 0) { return; }
						_hidden.jqVal('');
						that.value(active.data('val'));
						_selectedVal = null;
						that.close(_options);
					}
				}
			});

			var _keyInterval = null, _keyTimer = 0;
			el.off('keyup.slx.ac').on('keyup.slx.ac', function (event) {
				if (!_preventDefault(event)) { return; }
				else if (that.text().trim().length === 0) { that.close(); return; }
				_keyTimer = that.service !== null ? 10 : 0;
				if (_keyInterval === null) {
					_keyInterval = setInterval(function () {
						if (_keyTimer <= 0) {
							clearInterval(_keyInterval);
							_keyInterval = null;
							_keyTimer = 0;
							if (that.text().trim().length > 0) { that.search(that.text(), function () { if (el.is(':focus')) { that.open(); } }); }
							else { that.close(); }
						}
						_keyTimer--;
					}, 40);
				}
			});
			_btn.off('click.slx.ac').on('click.slx.ac', function (event) {
				_filtered = null;
				_btn.stopBubble(event);
				_options = that.container.find('.slx-autocomplete-options');
				if (_options.length > 0) {
					var active = _options.children('.active');
					if (active.length === 0) { return; }
					that.value(active.data('val'));
					that.close(_options);
				}
				else { that.search('', that.open); }
			});
			that.container.off('focusout.slx.ac').on('focusout.slx.ac', function (event) {
				if (that.container.find(':focus').length === 0) {
					_blurTimeout = setTimeout(function () {
						if (!_btn.is(':focus') && !_isScrolling) { that.close(_options); }
					}, 200);
				}
			});
			if (that.showArrow !== false) {
				x(window).off('resize.slx.ac.' + that.id).on('resize.slx.ac.' + that.id, function (event) {
					var c = that.container.width(), t = el.outerWidth();
					if (t - 2 <= c) { _btn.css('right', (c - t) + 'px'); }
					else if (t - 2 > c) { _btn.css('right', '-' + Math.round(t - c) + 'px'); }
				});
			}
		})();

		that.isScrolling = function () { return _isScrolling; };

		el[0].slxAutoComplete = this;
		el[0].isSlxControl = true;

		return el;
	};
	x.slx.autocomplete.prototype = Object.create(x.slx.base.prototype);
	x.slx.autocomplete.prototype.constructor = x.slx.autocomplete;

	/* jQuery extenders */
	x.fn.extend({
		slxAutoComplete: function () {
			var slx = this.slxControl('slxAutoComplete', arguments) || new x.slx.autocomplete(this, arguments);
			if (arguments.length > 0) {
				var arg = arguments[0], args = Array.prototype.slice.call(arguments, 1);
				if (typeof arg === 'string' && slx.hasOwnProperty(arg)) { return typeof (slx[arg]) === 'function' ? slx[arg].apply(slx, args) : slx[arg]; }
				else if (typeof arg !== 'string') { x.extend(slx, arg); }
			}
			return this;
		}
	});
	x(function () { x('.slx-autocomplete').each(function () { x(this).slxAutoComplete(); }); });

	return x;
})();